<script>
  import { html } from 'common-tags';

  import ChoiceInput from './choice-input.svelte';

  // TODO temporary placeholder icons:
  const NONE = html` <svg
    width="1rem"
    height="1rem"
    viewBox="0 -1 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
  >
    <g transform="matrix(1,0,0,1,-5.15,-4.25)">
      <g transform="matrix(0.863332,0,0,0.98048,3.31,2.05856)">
        <path
          d="M17.131,4.912C17.131,3.857 16.158,3 14.959,3L5.172,3C3.973,3 3,3.857 3,4.912L3,13.531C3,14.586 3.973,15.443 5.172,15.443L14.959,15.443C16.158,15.443 17.131,14.586 17.131,13.531L17.131,4.912Z"
          style="fill:none;stroke:currentcolor;stroke-width:1px;"
        />
      </g>
    </g>
  </svg>`;
  const SMALL = html` <svg
    width="1rem"
    height="1rem"
    viewBox="0 -1 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
  >
    <g transform="matrix(1,0,0,1,-4.4,-4.25)">
      <g transform="matrix(1,0,0,1,0.15,0)">
        <path
          id="M"
          d="M17.169,6.531C17.189,6.643 17.2,6.758 17.2,6.875L17.2,15.325C17.2,16.36 16.36,17.2 15.325,17.2L6.875,17.2C6.758,17.2 6.643,17.189 6.531,17.169C6.693,18.04 7.458,18.7 8.375,18.7L16.825,18.7C17.86,18.7 18.7,17.86 18.7,16.825L18.7,8.375C18.7,7.458 18.04,6.693 17.169,6.531Z"
          style="fill:currentcolor;stroke:currentcolor;stroke-width:1px;"
        />
        <g transform="matrix(0.863332,0,0,0.98048,2.41,2.05856)">
          <path
            d="M17.131,4.912C17.131,3.857 16.158,3 14.959,3L5.172,3C3.973,3 3,3.857 3,4.912L3,13.531C3,14.586 3.973,15.443 5.172,15.443L14.959,15.443C16.158,15.443 17.131,14.586 17.131,13.531L17.131,4.912Z"
            style="fill:none;stroke:currentcolor;stroke-width:1px;"
          />
        </g>
      </g>
    </g>
  </svg>`;
  const LARGE = html` <svg
    width="1rem"
    height="1rem"
    viewBox="0 0 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
  >
    <g transform="matrix(1,0,0,1,-3.65,-4.25)">
      <g transform="matrix(1,0,0,1,-0.6,0)">
        <path
          d="M17.2,8L17.2,15.325C17.2,16.36 16.36,17.2 15.325,17.2L8,17.2L8,18.325C8,19.36 8.84,20.2 9.875,20.2L18.325,20.2C19.36,20.2 20.2,19.36 20.2,18.325L20.2,9.875C20.2,8.84 19.36,8 18.325,8L17.2,8Z"
          style="fill:currentcolor;stroke:currentcolor;stroke-width:1px;"
        />
        <g transform="matrix(0.863332,0,0,0.98048,2.41,2.05856)">
          <path
            d="M17.131,4.912C17.131,3.857 16.158,3 14.959,3L5.172,3C3.973,3 3,3.857 3,4.912L3,13.531C3,14.586 3.973,15.443 5.172,15.443L14.959,15.443C16.158,15.443 17.131,14.586 17.131,13.531L17.131,4.912Z"
            style="fill:none;stroke:currentcolor;stroke-width:1px;"
          />
        </g>
      </g>
    </g>
  </svg>`;

  export let value;

  export let onChange = () => {};

  // TODO temporary icons, need to find appropriate ones:
  const options = [
    { value: 'none', label: 'none', html: NONE },
    { value: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.25)', label: 'small', html: SMALL },
    { value: '0 0.5rem 1rem rgba(0, 0, 0, 0.25)', label: 'large', html: LARGE }
  ];
</script>

<ChoiceInput editable {value} {options} {onChange} />
